import React, { createContext, useContext, useState, useEffect } from 'react';

// Comprehensive translation dictionary for ES / EN / PT.
// Falls back to Spanish if a key is missing in the active language.
const translations = {
  es: {
    // ============ Nav / shared ============
    dashboard: 'Panel',
    habits: 'Hábitos',
    goals: 'Metas',
    calendar: 'Calendario',
    visionboard: 'Vision Board',
    journal: 'Diario',
    achievements: 'Logros',
    budget: 'Presupuesto',
    clarity: 'Claridad',
    settings: 'Ajustes',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    your_personal_space: 'Tu espacio personal',
    premium: 'Premium',
    theme: 'Tema',
    select_theme: 'Seleccionar Tema',
    save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar', edit: 'Editar', add: 'Agregar',
    search: 'Buscar', today: 'Hoy', yesterday: 'Ayer',
    week: 'Semana', month: 'Mes', day: 'Día', year: 'Año',
    all: 'Todos', none: 'Ninguno', create: 'Crear', update: 'Actualizar',
    confirm: 'Confirmar', close: 'Cerrar', loading: 'Cargando...',
    register: 'Registrar', name: 'Nombre', remove: 'Quitar',
    yes: 'Sí', no: 'No', ok: 'OK', total: 'Total',
    optional: 'opcional', required: 'requerido', error: 'Error',
    no_data: 'Sin datos',
    sending: 'Enviando...',
    open_email: 'Abrir email',
    thinking: 'Pensando...',
    // ============ Dashboard greetings ============
    good_morning: 'Buenos días',
    good_afternoon: 'Buenas tardes',
    good_evening: 'Buenas noches',
    your_day_glance: 'Tu día en un vistazo',
    pending: 'pendiente', pendings: 'pendientes',
    completed_word: 'completado',
    daily_budget: 'Presupuesto del día',
    define_daily_budget: '+ Definir presupuesto del día',
    no_expenses_today: 'Sin gastos hoy',
    weekly_habits: 'Hábitos de la semana',
    todays_order: 'Orden del día',
    no_events_today: 'Sin eventos hoy',
    this_week: 'Esta semana',
    week_habits_title: 'Hábitos',
    active_goals: 'Metas activas',
    view_all: 'Ver todas',
    monthly_tracker: 'Ver tracker mensual',
    register_transaction: 'Registrar transacción',
    expense: 'Gasto', income_word: 'Ingreso',
    pick_category: 'Elegí una categoría',
    new_category: 'Nueva categoría',
    create_new: '+ Crear nueva',
    category_label: 'Categoría',
    description_label: 'Descripción',
    amount_label: 'Monto',
    quick_expense_hint: 'Se registra automáticamente en Presupuesto · Gastos',
    desc_placeholder: 'Describe el gasto...',
    no_category: 'Sin categoría',
    spent: 'Gastos',
    movements: 'Movimientos',
    days_word: 'Días',
    avg_per_day: 'Promedio/día',
    excedido: 'Excedido',
    restante: 'Restante',
    define_budget: 'Definí un presupuesto',
    week_review: 'Esta semana',
    events_lbl: 'Eventos',
    // Habits
    add_habit: 'Hábito', active_days: 'Días activos',
    weekdays_only: 'Solo días de semana', every_day: 'Todos los días',
    wellness: 'Bienestar',
    // Budget
    income: 'Ingresos', expenses: 'Gastos', fixed_expenses: 'Gastos fijos',
    savings: 'Ahorros', investment: 'Inversión', debt: 'Deuda',
    category: 'Categoría', description: 'Descripción', amount: 'Monto',
    date: 'Fecha', paid: 'Pagado', monthly: 'Mensual', saved: 'Ahorrado', target: 'Objetivo',
    summary: 'Resumen', financial_summary: 'Estado financiero',
    balance_month: 'Balance del mes', available: 'Disponible',
    expense_tracker: 'Tracker de Gastos del día', monthly_budget_tab: 'Presupuesto Mensual',
    category_budget: 'Presupuesto por categoría',
    by_category: 'Gastos por categoría', by_source: 'Ingresos por fuente',
    budget_vs_actual: 'Presupuesto vs Actual',
    new_savings_goal: 'Nueva Meta de Ahorro',
    monthly_expected: 'Mensual esperado', total_saved: 'Total ahorrado',
    total_goal: 'Meta total', missing: 'Falta',
    contributed_this_month: 'Aportado este mes', not_contributed_yet: 'Aún no aportaste este mes',
    contribute_monthly: 'Marcar aporte de este mes',
    months_remaining: 'Meses restantes',
    diff: 'Diferencia',
    // Goals
    new_goal: 'Nueva Meta', add_step: 'Agregar Paso', add_to_calendar: 'Agregar al calendario',
    // Calendar
    new_event: 'Nuevo evento', delete_event: 'Eliminar', event_title: 'Título del evento',
    starts: 'Inicio', ends: 'Fin', custom_color: 'Color personalizado',
    fixed_act: 'Actividad Fija', assignment: 'Asignación', learning: 'Aprendizaje',
    meeting: 'Reunión', social: 'Social', personal: 'Personal',
    edit_event: 'Editar Evento', ai_assistant: 'Asistente IA',
    organize_week_ai: 'Organizar Semana con IA',
    reset_week: 'Reiniciar Semana',
    time_blocks: 'Bloques de Tiempo', day_summary: 'Resumen del Día',
    busy_hours: 'Horas ocupadas', categories_lbl: 'Categorías',
    add_event: 'agregar evento', your_time: 'Tu tiempo',
    // Journal
    new_entry: 'Nueva Entrada', new_book: 'Nuevo Diario',
    journal_title_placeholder: 'Título de la entrada',
    write_here: 'Escribe libremente aquí...',
    // VisionBoard
    add_image: 'Agregar imagen', new_folder: 'Nueva Carpeta',
    // Achievements
    your_achievements: 'Tus Logros',
    // ============ Auth ============
    sign_in: 'Iniciar Sesión', sign_up: 'Registrarse',
    email: 'Email', password: 'Contraseña',
    continue_with_google: 'Continuar con Google',
    or_continue_with: 'o continuar con',
    auth_tagline: 'Tu espacio de productividad personal',
    auth_create_account: 'Crear Cuenta',
    auth_full_name_placeholder: 'Nombre completo',
    auth_welcome_back: 'Bienvenido de vuelta',
    auth_enter_name: 'Ingresa tu nombre',
    auth_account_created: 'Cuenta creada exitosamente',
    auth_generic_error: 'Error de autenticación',
    authenticating_google: 'Autenticando con Google...',
    // ============ Public layout (header/footer) ============
    nav_home: 'Inicio',
    nav_plans: 'Planes',
    nav_contact: 'Contacto',
    nav_privacy: 'Privacidad',
    nav_terms: 'Términos',
    nav_refunds: 'Reembolsos',
    open_teko: 'Abrir Teko',
    start_free: 'Empezar gratis',
    menu: 'Menú',
    footer_tagline: 'Tu espacio personal para hábitos, objetivos y claridad mental. Diseñado para que avances con intención cada día.',
    footer_product: 'Producto',
    footer_legal: 'Legal',
    footer_contact: 'Contacto',
    footer_features: 'Funciones',
    footer_plans: 'Planes',
    footer_login: 'Iniciar sesión',
    footer_privacy_policy: 'Política de Privacidad',
    footer_terms_conditions: 'Términos y Condiciones',
    footer_refund_policy: 'Cancelaciones y Reembolsos',
    footer_contact_form: 'Formulario de contacto',
    footer_rights: 'Todos los derechos reservados.',
    footer_payments_secure: 'Pagos procesados de forma segura por nuestro proveedor de pagos autorizado.',
    // ============ Landing ============
    landing_badge: 'Tu espacio personal de productividad',
    landing_hero_title_1: 'Avanza con intención,',
    landing_hero_title_2: 'todos los días',
    landing_hero_subtitle: 'Teko reúne hábitos, metas, calendario, diario, presupuesto y claridad mental en una sola app pensada para acompañarte sin abrumar.',
    landing_cta_primary: 'Empezar gratis',
    landing_cta_secondary: 'Ver planes',
    landing_hero_disclaimer: 'Sin tarjeta de crédito para empezar · Cancelas cuando quieras',
    landing_features_label: 'Funciones',
    landing_features_title: 'Todo lo que necesitas, en un solo lugar',
    landing_benefits_label: 'Por qué Teko',
    landing_benefits_title: 'Productividad sin perder humanidad',
    landing_plans_label: 'Planes',
    landing_plans_title: 'Elige el ritmo que te resulte cómodo',
    landing_plans_subtitle_pre: 'Empieza gratis y cambia de plan cuando lo necesites. Solo',
    landing_plans_subtitle_post: 'desbloquea el módulo Presupuesto.',
    plan_most_popular: 'Más popular',
    plan_period_month: 'mes',
    plan_period_months: 'meses',
    plan_credits_unlimited: 'Créditos IA ilimitados',
    plan_credits_count: 'créditos IA',
    plan_boards_unlimited: 'Tableros ilimitados',
    plan_boards_count: 'tablero(s)',
    plan_habits_unlimited: 'Hábitos ilimitados',
    plan_habits_count: 'hábitos',
    plan_budget_included: 'Presupuesto incluido',
    plan_budget_excluded: 'Presupuesto no incluido',
    plan_btn_start_free: 'Empezar gratis',
    plan_btn_subscribe: 'Suscribirme',
    landing_cta_final_title: 'Empieza hoy. Tu próximo año te va a agradecer.',
    landing_cta_final_subtitle: 'Crea tu cuenta gratis en menos de 1 minuto. Sin tarjeta. Sin compromiso.',
    landing_cta_final_btn: 'Crear mi cuenta gratis',
    landing_questions: '¿Dudas? Escríbenos a',
    // Plan taglines
    tag_free: 'Plan inicial · Gratis para siempre',
    tag_light: 'Para mantener el ritmo',
    tag_pro: 'Para trabajar mejor',
    tag_vip: 'Sin límites · Presupuesto incluido',
    tag_trimestral: 'Mejor valor a largo plazo',
    // Landing features (title + desc pairs)
    feat_vb_t: 'Vision Board',
    feat_vb_d: 'Sube imágenes, frases y collages que representen lo que quieres atraer. Tableros ilimitados, drag-and-drop libre.',
    feat_habits_t: 'Hábitos diarios',
    feat_habits_d: 'Define rutinas, marca tu check-in y observa tu racha y porcentaje de cumplimiento del mes con recordatorios.',
    feat_goals_t: 'Metas con IA',
    feat_goals_d: 'Escribe tu meta y la IA te genera los pasos accionables. Llévalos al calendario en un clic.',
    feat_cal_t: 'Calendario time-blocking',
    feat_cal_d: 'Vista por día, semana o mes con bloques arrastrables. La IA puede organizarte la semana.',
    feat_journal_t: 'Diario libre',
    feat_journal_d: 'Escribe sin filtro. La IA acompaña con reflexiones empáticas y preguntas abiertas. Múltiples cuadernos.',
    feat_clarity_t: 'Claridad Mental',
    feat_clarity_d: 'Bandeja de ideas con 3 zonas (Postergable / Prioridad / Ruido). Para vaciar la cabeza en 2 minutos.',
    feat_achv_t: 'Archivo de logros',
    feat_achv_d: 'Cada meta cumplida queda guardada como recordatorio de todo lo que ya conseguiste.',
    feat_budget_t: 'Presupuesto',
    feat_budget_d: 'Tablas financieras, tracker diario, savings goals, proyecciones y saldo histórico acumulativo.',
    bnf_rhythm_t: 'Hecho para tu ritmo',
    bnf_rhythm_d: 'No es una app de productividad agresiva. Avanzas con calma, sin culpa, con tu energía.',
    bnf_data_t: 'Tus datos, tuyos',
    bnf_data_d: 'Encriptación de tránsito, control total sobre tu información y posibilidad de exportar todo cuando quieras.',
    bnf_pay_t: 'Pagos seguros',
    bnf_pay_d: 'Procesamos pagos a través de un proveedor de servicios de pago autorizado. Tus datos de tarjeta nunca pasan por nuestros servidores.',
    // ============ Contact ============
    contact_kicker: 'Contacto',
    contact_title: 'Hablemos',
    contact_subtitle: 'Si tienes una consulta, sugerencia, problema técnico o quieres cancelar tu suscripción, escríbenos. Respondemos en 24-48hs hábiles.',
    contact_email_label: 'Correo de contacto',
    contact_field_name: 'Nombre',
    contact_field_email: 'Email',
    contact_field_subject: 'Asunto',
    contact_field_message: 'Mensaje',
    contact_subject_placeholder: 'Consulta general, problema técnico, cancelación...',
    contact_message_placeholder: 'Cuéntanos en qué podemos ayudarte...',
    contact_send: 'Enviar mensaje',
    contact_required_fields: 'Completa nombre, email y mensaje',
    contact_sent_title: '¡Recibimos tu mensaje!',
    contact_sent_body_pre: 'Te respondemos a',
    contact_sent_body_post: 'en las próximas 24-48hs hábiles.',
    contact_send_another: 'Enviar otro mensaje',
    contact_success_toast: '¡Mensaje enviado! Te respondemos a la brevedad.',
    contact_error_toast: 'No pudimos enviar el mensaje. Prueba el botón "Abrir email".',
    contact_consent: 'Al enviar, aceptas nuestra',
    contact_consent_link: 'política de privacidad',
    contact_default_subject: 'Consulta desde Teko',
    // ============ Notifications ============
    notifications: 'Notificaciones',
    notif_aria: 'Notificaciones',
    notif_empty: 'No tienes notificaciones.',
    notif_empty_hint: 'Te avisaremos sobre hábitos pendientes, eventos próximos y metas cercanas a vencer.',
    notif_mark_all: 'Marcar leídas',
    notif_mark_one: 'Marcar leída',
    notif_remove: 'Eliminar',
    notif_new_badge: 'nuevas',
    notif_just_now: 'hace un momento',
    notif_minutes_ago: 'min',
    notif_hours_ago: 'h',
    // ============ Onboarding tour ============
    tour_skip: 'Saltar tour',
    tour_prev: 'Anterior',
    tour_next: 'Siguiente',
    tour_start: 'Empezar',
    tour_step: 'Paso',
    tour_of: 'de',
    tour_close: 'Cerrar tour',
    tour_1_t: '¡Bienvenido a Teko!',
    tour_1_b: 'Soy tu guía. Te voy a mostrar las funciones clave en 30 segundos. Puedes saltar el tour cuando quieras — siempre puedes volver a abrirlo desde el botón "Guía Teko" abajo a la derecha.',
    tour_2_t: 'Panel principal',
    tour_2_b: 'Aquí ves tu resumen del día: hábitos pendientes, metas activas, próximos eventos y un resumen semanal generado por IA.',
    tour_3_t: 'Vision Board',
    tour_3_b: 'Sube imágenes, frases y collages que representen lo que quieres atraer. Puedes crear varios tableros y arrastrar elementos libremente.',
    tour_4_t: 'Hábitos',
    tour_4_b: 'Define hábitos diarios o semanales, marca tu check-in y observa tu racha y porcentaje de cumplimiento del mes. Los recordatorios aparecen en notificaciones.',
    tour_5_t: 'Metas con IA',
    tour_5_b: 'Escribe una meta y la IA te genera los pasos accionables. Después puedes llevar cada paso al calendario en un clic.',
    tour_6_t: 'Calendario time-blocking',
    tour_6_b: 'Vista por día, semana o mes con bloques arrastrables. La IA puede organizarte la semana si le cuentas tus prioridades.',
    tour_7_t: 'Diario libre',
    tour_7_b: 'Escribe sin filtro. La IA te acompaña con reflexiones empáticas y preguntas abiertas. Soporta múltiples cuadernos por temática.',
    tour_8_t: 'Logros',
    tour_8_b: 'Cada meta cumplida queda archivada aquí como recordatorio de todo lo que ya conseguiste.',
    tour_9_t: 'Claridad Mental',
    tour_9_b: 'Bandeja de ideas con drag-and-drop a 3 zonas: Postergable, Prioridad y Ruido. Para vaciar la cabeza en 2 minutos.',
    tour_10_t: 'Presupuesto',
    tour_10_b: 'Tablas financieras, tracker de gastos del día, savings goals y proyecciones. Esta sección es exclusiva del plan Premium.',
    tour_11_t: 'Membresía',
    tour_11_b: 'Elige el plan que más te convenga. Free es perfecto para arrancar, Premium desbloquea todo. Puedes cambiar o cancelar cuando quieras.',
    tour_12_t: '¡Listo para empezar!',
    tour_12_b: 'Ya tienes lo básico. Recuerda: el botón "Guía Teko" abajo a la derecha te abre un chat con IA por si tienes dudas más específicas.',
    // ============ Tutorial chat ============
    chat_greeting: '¡Hola! Soy la guía de Teko. Pregúntame cualquier cosa sobre las funciones de la app — estoy aquí para ayudarte.',
    chat_subtitle: 'Te ayudo con cualquier función',
    chat_open_aria: 'Abrir guía de Teko',
    chat_title: 'Guía Teko',
    chat_tour_btn: 'Tour',
    chat_close_aria: 'Cerrar',
    chat_send_aria: 'Enviar',
    chat_placeholder: 'Pregunta algo...',
    chat_error: 'Lo siento, no pude responder ahora mismo. Inténtalo de nuevo en unos segundos.',
    chat_sug_1: '¿Cómo agrego un hábito?',
    chat_sug_2: '¿Para qué sirve Claridad Mental?',
    chat_sug_3: '¿Cómo funciona el plan Premium?',
    chat_sug_4: '¿Cómo genero metas con IA?',
  },

  en: {
    dashboard: 'Dashboard', habits: 'Habits', goals: 'Goals',
    calendar: 'Calendar', visionboard: 'Vision Board', journal: 'Journal',
    achievements: 'Achievements', budget: 'Budget', clarity: 'Clarity', settings: 'Settings',
    logout: 'Sign out', profile: 'Profile',
    your_personal_space: 'Your personal space',
    premium: 'Premium', theme: 'Theme', select_theme: 'Select Theme',
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', add: 'Add',
    search: 'Search', today: 'Today', yesterday: 'Yesterday',
    week: 'Week', month: 'Month', day: 'Day', year: 'Year',
    all: 'All', none: 'None', create: 'Create', update: 'Update',
    confirm: 'Confirm', close: 'Close', loading: 'Loading...',
    register: 'Register', name: 'Name', remove: 'Remove',
    yes: 'Yes', no: 'No', ok: 'OK', total: 'Total',
    optional: 'optional', required: 'required', error: 'Error',
    no_data: 'No data',
    sending: 'Sending...',
    open_email: 'Open email',
    thinking: 'Thinking...',
    good_morning: 'Good morning', good_afternoon: 'Good afternoon', good_evening: 'Good evening',
    your_day_glance: 'Today at a glance',
    pending: 'pending', pendings: 'pending',
    completed_word: 'completed',
    daily_budget: "Today's budget",
    define_daily_budget: "+ Set today's budget",
    no_expenses_today: 'No expenses today',
    weekly_habits: 'Weekly habits',
    todays_order: "Today's plan",
    no_events_today: 'No events today',
    this_week: 'This week', week_habits_title: 'Habits',
    active_goals: 'Active goals', view_all: 'View all',
    monthly_tracker: 'View monthly tracker',
    register_transaction: 'Register transaction',
    expense: 'Expense', income_word: 'Income',
    pick_category: 'Pick a category', new_category: 'New category',
    create_new: '+ Create new',
    category_label: 'Category', description_label: 'Description', amount_label: 'Amount',
    quick_expense_hint: 'Auto-saved to Budget · Expenses',
    desc_placeholder: 'Describe the expense...',
    no_category: 'No category', spent: 'Spent', movements: 'Entries',
    days_word: 'Days', avg_per_day: 'Avg/day',
    excedido: 'Over', restante: 'Left',
    define_budget: 'Set a budget',
    week_review: 'This week', events_lbl: 'Events',
    add_habit: 'Habit', active_days: 'Active days',
    weekdays_only: 'Weekdays only', every_day: 'Every day',
    wellness: 'Wellness',
    income: 'Income', expenses: 'Expenses', fixed_expenses: 'Fixed expenses',
    savings: 'Savings', investment: 'Investment', debt: 'Debt',
    category: 'Category', description: 'Description', amount: 'Amount',
    date: 'Date', paid: 'Paid', monthly: 'Monthly', saved: 'Saved', target: 'Target',
    summary: 'Summary', financial_summary: 'Financial overview',
    balance_month: 'Month balance', available: 'Available',
    expense_tracker: 'Daily Expense Tracker', monthly_budget_tab: 'Monthly Budget',
    category_budget: 'Category budget',
    by_category: 'Expenses by category', by_source: 'Income by source',
    budget_vs_actual: 'Budget vs Actual',
    new_savings_goal: 'New Savings Goal',
    monthly_expected: 'Expected monthly', total_saved: 'Total saved',
    total_goal: 'Total goal', missing: 'Left',
    contributed_this_month: 'Contributed this month', not_contributed_yet: "Haven't contributed this month",
    contribute_monthly: 'Mark this month contribution',
    months_remaining: 'Months remaining',
    diff: 'Difference',
    new_goal: 'New Goal', add_step: 'Add Step', add_to_calendar: 'Add to calendar',
    new_event: 'New event', delete_event: 'Delete', event_title: 'Event title',
    starts: 'Starts', ends: 'Ends', custom_color: 'Custom color',
    fixed_act: 'Fixed Activity', assignment: 'Assignment', learning: 'Learning',
    meeting: 'Meeting', social: 'Social', personal: 'Personal',
    edit_event: 'Edit Event', ai_assistant: 'AI Assistant',
    organize_week_ai: 'Organize Week with AI',
    reset_week: 'Reset Week',
    time_blocks: 'Time Blocks', day_summary: 'Day Summary',
    busy_hours: 'Busy hours', categories_lbl: 'Categories',
    add_event: 'add event', your_time: 'Your time',
    new_entry: 'New Entry', new_book: 'New Journal',
    journal_title_placeholder: 'Entry title',
    write_here: 'Write freely here...',
    add_image: 'Add image', new_folder: 'New Folder',
    your_achievements: 'Your Achievements',
    // Auth
    sign_in: 'Sign In', sign_up: 'Sign Up',
    email: 'Email', password: 'Password',
    continue_with_google: 'Continue with Google',
    or_continue_with: 'or continue with',
    auth_tagline: 'Your personal productivity space',
    auth_create_account: 'Create Account',
    auth_full_name_placeholder: 'Full name',
    auth_welcome_back: 'Welcome back',
    auth_enter_name: 'Please enter your name',
    auth_account_created: 'Account created successfully',
    auth_generic_error: 'Authentication error',
    authenticating_google: 'Authenticating with Google...',
    // Public layout
    nav_home: 'Home',
    nav_plans: 'Plans',
    nav_contact: 'Contact',
    nav_privacy: 'Privacy',
    nav_terms: 'Terms',
    nav_refunds: 'Refunds',
    open_teko: 'Open Teko',
    start_free: 'Start free',
    menu: 'Menu',
    footer_tagline: 'Your personal space for habits, goals and mental clarity. Designed to help you move forward with intention every day.',
    footer_product: 'Product',
    footer_legal: 'Legal',
    footer_contact: 'Contact',
    footer_features: 'Features',
    footer_plans: 'Plans',
    footer_login: 'Sign in',
    footer_privacy_policy: 'Privacy Policy',
    footer_terms_conditions: 'Terms & Conditions',
    footer_refund_policy: 'Cancellations & Refunds',
    footer_contact_form: 'Contact form',
    footer_rights: 'All rights reserved.',
    footer_payments_secure: 'Payments securely processed by our authorized payment provider.',
    // Landing
    landing_badge: 'Your personal productivity space',
    landing_hero_title_1: 'Move forward with intention,',
    landing_hero_title_2: 'every day',
    landing_hero_subtitle: 'Teko brings together habits, goals, calendar, journal, budget and mental clarity in one app designed to support you without overwhelming.',
    landing_cta_primary: 'Start free',
    landing_cta_secondary: 'See plans',
    landing_hero_disclaimer: 'No credit card to start · Cancel anytime',
    landing_features_label: 'Features',
    landing_features_title: 'Everything you need, in one place',
    landing_benefits_label: 'Why Teko',
    landing_benefits_title: 'Productivity without losing humanity',
    landing_plans_label: 'Plans',
    landing_plans_title: 'Pick the pace that suits you',
    landing_plans_subtitle_pre: 'Start free and upgrade when you need to. Only',
    landing_plans_subtitle_post: 'unlocks the Budget module.',
    plan_most_popular: 'Most popular',
    plan_period_month: 'month',
    plan_period_months: 'months',
    plan_credits_unlimited: 'Unlimited AI credits',
    plan_credits_count: 'AI credits',
    plan_boards_unlimited: 'Unlimited boards',
    plan_boards_count: 'board(s)',
    plan_habits_unlimited: 'Unlimited habits',
    plan_habits_count: 'habits',
    plan_budget_included: 'Budget included',
    plan_budget_excluded: 'Budget not included',
    plan_btn_start_free: 'Start free',
    plan_btn_subscribe: 'Subscribe',
    landing_cta_final_title: 'Start today. Your future self will thank you.',
    landing_cta_final_subtitle: 'Create your free account in under 1 minute. No card. No commitment.',
    landing_cta_final_btn: 'Create my free account',
    landing_questions: 'Questions? Write to us at',
    tag_free: 'Starter plan · Free forever',
    tag_light: 'To keep the rhythm',
    tag_pro: 'To work better',
    tag_vip: 'No limits · Budget included',
    tag_trimestral: 'Best long-term value',
    feat_vb_t: 'Vision Board',
    feat_vb_d: 'Upload images, quotes and collages that represent what you want to attract. Unlimited boards, free drag-and-drop.',
    feat_habits_t: 'Daily habits',
    feat_habits_d: 'Define routines, mark your check-in and see your streak and monthly completion rate with reminders.',
    feat_goals_t: 'Goals with AI',
    feat_goals_d: 'Write your goal and AI generates actionable steps. Send them to the calendar in one click.',
    feat_cal_t: 'Time-blocking calendar',
    feat_cal_d: 'Day, week or month view with draggable blocks. AI can organize your week.',
    feat_journal_t: 'Free journaling',
    feat_journal_d: 'Write without filter. AI accompanies you with empathetic reflections and open questions. Multiple notebooks.',
    feat_clarity_t: 'Mental Clarity',
    feat_clarity_d: 'Idea inbox with 3 zones (Postponable / Priority / Noise). To empty your head in 2 minutes.',
    feat_achv_t: 'Achievements archive',
    feat_achv_d: 'Every completed goal stays saved as a reminder of everything you have already accomplished.',
    feat_budget_t: 'Budget',
    feat_budget_d: 'Financial tables, daily tracker, savings goals, projections and cumulative historical balance.',
    bnf_rhythm_t: 'Made for your pace',
    bnf_rhythm_d: "It's not an aggressive productivity app. You move forward calmly, without guilt, with your own energy.",
    bnf_data_t: 'Your data, yours',
    bnf_data_d: 'Encryption in transit, full control over your information and the ability to export everything whenever you want.',
    bnf_pay_t: 'Safe payments',
    bnf_pay_d: 'We process payments through an authorized payment service provider. Your card details never pass through our servers.',
    // Contact
    contact_kicker: 'Contact',
    contact_title: "Let's talk",
    contact_subtitle: 'If you have a question, suggestion, technical issue or want to cancel your subscription, write to us. We reply within 24-48 business hours.',
    contact_email_label: 'Contact email',
    contact_field_name: 'Name',
    contact_field_email: 'Email',
    contact_field_subject: 'Subject',
    contact_field_message: 'Message',
    contact_subject_placeholder: 'General inquiry, technical issue, cancellation...',
    contact_message_placeholder: 'Tell us how we can help...',
    contact_send: 'Send message',
    contact_required_fields: 'Please fill in name, email and message',
    contact_sent_title: 'Message received!',
    contact_sent_body_pre: "We'll reply to",
    contact_sent_body_post: 'within the next 24-48 business hours.',
    contact_send_another: 'Send another message',
    contact_success_toast: 'Message sent! We will reply shortly.',
    contact_error_toast: 'We could not send the message. Try the "Open email" button.',
    contact_consent: 'By sending, you accept our',
    contact_consent_link: 'privacy policy',
    contact_default_subject: 'Inquiry from Teko',
    // Notifications
    notifications: 'Notifications',
    notif_aria: 'Notifications',
    notif_empty: "You don't have notifications.",
    notif_empty_hint: "We'll alert you about pending habits, upcoming events and goals close to their due date.",
    notif_mark_all: 'Mark as read',
    notif_mark_one: 'Mark as read',
    notif_remove: 'Delete',
    notif_new_badge: 'new',
    notif_just_now: 'just now',
    notif_minutes_ago: 'min',
    notif_hours_ago: 'h',
    // Onboarding
    tour_skip: 'Skip tour',
    tour_prev: 'Previous',
    tour_next: 'Next',
    tour_start: 'Get started',
    tour_step: 'Step',
    tour_of: 'of',
    tour_close: 'Close tour',
    tour_1_t: 'Welcome to Teko!',
    tour_1_b: "I'm your guide. I'll show you the key features in 30 seconds. You can skip the tour anytime — you can always reopen it from the \"Teko Guide\" button at the bottom right.",
    tour_2_t: 'Main dashboard',
    tour_2_b: "Here you'll see your daily summary: pending habits, active goals, upcoming events and an AI-generated weekly summary.",
    tour_3_t: 'Vision Board',
    tour_3_b: 'Upload images, quotes and collages that represent what you want to attract. You can create multiple boards and drag elements freely.',
    tour_4_t: 'Habits',
    tour_4_b: 'Define daily or weekly habits, mark your check-in and see your streak and monthly completion rate. Reminders appear in notifications.',
    tour_5_t: 'Goals with AI',
    tour_5_b: 'Write a goal and AI generates actionable steps. Then you can send each step to the calendar in one click.',
    tour_6_t: 'Time-blocking calendar',
    tour_6_b: 'Day, week or month view with draggable blocks. AI can organize your week if you share your priorities.',
    tour_7_t: 'Free journaling',
    tour_7_b: 'Write without filter. AI accompanies you with empathetic reflections and open questions. Supports multiple themed notebooks.',
    tour_8_t: 'Achievements',
    tour_8_b: 'Every completed goal is archived here as a reminder of everything you have already accomplished.',
    tour_9_t: 'Mental Clarity',
    tour_9_b: 'Idea inbox with drag-and-drop to 3 zones: Postponable, Priority and Noise. To empty your head in 2 minutes.',
    tour_10_t: 'Budget',
    tour_10_b: 'Financial tables, daily expense tracker, savings goals and projections. This section is exclusive to the Premium plan.',
    tour_11_t: 'Membership',
    tour_11_b: 'Pick the plan that fits you. Free is perfect to start, Premium unlocks everything. You can change or cancel anytime.',
    tour_12_t: "Ready to start!",
    tour_12_b: 'You have the basics. Remember: the "Teko Guide" button at the bottom right opens a chat with AI in case you have more specific questions.',
    // Tutorial chat
    chat_greeting: "Hi! I'm the Teko guide. Ask me anything about the app's features — I'm here to help.",
    chat_subtitle: 'I help with any feature',
    chat_open_aria: 'Open Teko guide',
    chat_title: 'Teko Guide',
    chat_tour_btn: 'Tour',
    chat_close_aria: 'Close',
    chat_send_aria: 'Send',
    chat_placeholder: 'Ask something...',
    chat_error: "Oops, I couldn't respond right now. Try again in a few seconds.",
    chat_sug_1: 'How do I add a habit?',
    chat_sug_2: 'What is Mental Clarity for?',
    chat_sug_3: 'How does the Premium plan work?',
    chat_sug_4: 'How do I generate goals with AI?',
  },

  pt: {
    dashboard: 'Painel', habits: 'Hábitos', goals: 'Metas',
    calendar: 'Calendário', visionboard: 'Vision Board', journal: 'Diário',
    achievements: 'Conquistas', budget: 'Orçamento', clarity: 'Clareza', settings: 'Ajustes',
    logout: 'Sair', profile: 'Perfil',
    your_personal_space: 'Seu espaço pessoal',
    premium: 'Premium', theme: 'Tema', select_theme: 'Selecionar Tema',
    save: 'Salvar', cancel: 'Cancelar', delete: 'Excluir', edit: 'Editar', add: 'Adicionar',
    search: 'Buscar', today: 'Hoje', yesterday: 'Ontem',
    week: 'Semana', month: 'Mês', day: 'Dia', year: 'Ano',
    all: 'Todos', none: 'Nenhum', create: 'Criar', update: 'Atualizar',
    confirm: 'Confirmar', close: 'Fechar', loading: 'Carregando...',
    register: 'Registrar', name: 'Nome', remove: 'Remover',
    yes: 'Sim', no: 'Não', ok: 'OK', total: 'Total',
    optional: 'opcional', required: 'requerido', error: 'Erro',
    no_data: 'Sem dados',
    sending: 'Enviando...',
    open_email: 'Abrir email',
    thinking: 'Pensando...',
    good_morning: 'Bom dia', good_afternoon: 'Boa tarde', good_evening: 'Boa noite',
    your_day_glance: 'Seu dia em um relance',
    pending: 'pendente', pendings: 'pendentes',
    completed_word: 'concluído',
    daily_budget: 'Orçamento do dia',
    define_daily_budget: '+ Definir orçamento do dia',
    no_expenses_today: 'Sem gastos hoje',
    weekly_habits: 'Hábitos da semana',
    todays_order: 'Programação de hoje',
    no_events_today: 'Sem eventos hoje',
    this_week: 'Esta semana', week_habits_title: 'Hábitos',
    active_goals: 'Metas ativas', view_all: 'Ver todas',
    monthly_tracker: 'Ver controle mensal',
    register_transaction: 'Registrar transação',
    expense: 'Despesa', income_word: 'Receita',
    pick_category: 'Escolha uma categoria', new_category: 'Nova categoria',
    create_new: '+ Criar nova',
    category_label: 'Categoria', description_label: 'Descrição', amount_label: 'Valor',
    quick_expense_hint: 'Salvo automaticamente em Orçamento · Despesas',
    desc_placeholder: 'Descreva a despesa...',
    no_category: 'Sem categoria', spent: 'Gastos', movements: 'Movimentos',
    days_word: 'Dias', avg_per_day: 'Média/dia',
    excedido: 'Excedido', restante: 'Restante',
    define_budget: 'Defina um orçamento',
    week_review: 'Esta semana', events_lbl: 'Eventos',
    add_habit: 'Hábito', active_days: 'Dias ativos',
    weekdays_only: 'Só dias úteis', every_day: 'Todos os dias',
    wellness: 'Bem-estar',
    income: 'Receitas', expenses: 'Despesas', fixed_expenses: 'Despesas fixas',
    savings: 'Poupanças', investment: 'Investimento', debt: 'Dívida',
    category: 'Categoria', description: 'Descrição', amount: 'Valor',
    date: 'Data', paid: 'Pago', monthly: 'Mensal', saved: 'Poupado', target: 'Meta',
    summary: 'Resumo', financial_summary: 'Resumo financeiro',
    balance_month: 'Saldo do mês', available: 'Disponível',
    expense_tracker: 'Rastreador de Despesas do dia', monthly_budget_tab: 'Orçamento Mensal',
    category_budget: 'Orçamento por categoria',
    by_category: 'Despesas por categoria', by_source: 'Receitas por fonte',
    budget_vs_actual: 'Orçamento vs Real',
    new_savings_goal: 'Nova Meta de Poupança',
    monthly_expected: 'Mensal esperado', total_saved: 'Total poupado',
    total_goal: 'Meta total', missing: 'Falta',
    contributed_this_month: 'Aportado este mês', not_contributed_yet: 'Ainda não aportou este mês',
    contribute_monthly: 'Marcar aporte deste mês',
    months_remaining: 'Meses restantes',
    diff: 'Diferença',
    new_goal: 'Nova Meta', add_step: 'Adicionar Passo', add_to_calendar: 'Adicionar ao calendário',
    new_event: 'Novo evento', delete_event: 'Excluir', event_title: 'Título do evento',
    starts: 'Início', ends: 'Fim', custom_color: 'Cor personalizada',
    fixed_act: 'Atividade Fixa', assignment: 'Tarefa', learning: 'Aprendizagem',
    meeting: 'Reunião', social: 'Social', personal: 'Pessoal',
    edit_event: 'Editar Evento', ai_assistant: 'Assistente IA',
    organize_week_ai: 'Organizar Semana com IA',
    reset_week: 'Reiniciar Semana',
    time_blocks: 'Blocos de Tempo', day_summary: 'Resumo do Dia',
    busy_hours: 'Horas ocupadas', categories_lbl: 'Categorias',
    add_event: 'adicionar evento', your_time: 'Seu tempo',
    new_entry: 'Nova Entrada', new_book: 'Novo Diário',
    journal_title_placeholder: 'Título da entrada',
    write_here: 'Escreva livremente aqui...',
    add_image: 'Adicionar imagem', new_folder: 'Nova Pasta',
    your_achievements: 'Suas Conquistas',
    // Auth
    sign_in: 'Entrar', sign_up: 'Cadastrar',
    email: 'Email', password: 'Senha',
    continue_with_google: 'Continuar com Google',
    or_continue_with: 'ou continuar com',
    auth_tagline: 'Seu espaço de produtividade pessoal',
    auth_create_account: 'Criar Conta',
    auth_full_name_placeholder: 'Nome completo',
    auth_welcome_back: 'Bem-vindo de volta',
    auth_enter_name: 'Digite seu nome',
    auth_account_created: 'Conta criada com sucesso',
    auth_generic_error: 'Erro de autenticação',
    authenticating_google: 'Autenticando com Google...',
    // Public layout
    nav_home: 'Início',
    nav_plans: 'Planos',
    nav_contact: 'Contato',
    nav_privacy: 'Privacidade',
    nav_terms: 'Termos',
    nav_refunds: 'Reembolsos',
    open_teko: 'Abrir Teko',
    start_free: 'Começar grátis',
    menu: 'Menu',
    footer_tagline: 'Seu espaço pessoal para hábitos, objetivos e clareza mental. Projetado para que você avance com intenção todos os dias.',
    footer_product: 'Produto',
    footer_legal: 'Legal',
    footer_contact: 'Contato',
    footer_features: 'Funcionalidades',
    footer_plans: 'Planos',
    footer_login: 'Entrar',
    footer_privacy_policy: 'Política de Privacidade',
    footer_terms_conditions: 'Termos e Condições',
    footer_refund_policy: 'Cancelamentos e Reembolsos',
    footer_contact_form: 'Formulário de contato',
    footer_rights: 'Todos os direitos reservados.',
    footer_payments_secure: 'Pagamentos processados com segurança por nosso provedor de pagamentos autorizado.',
    // Landing
    landing_badge: 'Seu espaço pessoal de produtividade',
    landing_hero_title_1: 'Avance com intenção,',
    landing_hero_title_2: 'todos os dias',
    landing_hero_subtitle: 'Teko reúne hábitos, metas, calendário, diário, orçamento e clareza mental em um único app pensado para acompanhar você sem sobrecarregar.',
    landing_cta_primary: 'Começar grátis',
    landing_cta_secondary: 'Ver planos',
    landing_hero_disclaimer: 'Sem cartão de crédito para começar · Cancele quando quiser',
    landing_features_label: 'Funcionalidades',
    landing_features_title: 'Tudo o que você precisa, em um só lugar',
    landing_benefits_label: 'Por que Teko',
    landing_benefits_title: 'Produtividade sem perder humanidade',
    landing_plans_label: 'Planos',
    landing_plans_title: 'Escolha o ritmo que combina com você',
    landing_plans_subtitle_pre: 'Comece grátis e mude de plano quando precisar. Só',
    landing_plans_subtitle_post: 'desbloqueia o módulo Orçamento.',
    plan_most_popular: 'Mais popular',
    plan_period_month: 'mês',
    plan_period_months: 'meses',
    plan_credits_unlimited: 'Créditos IA ilimitados',
    plan_credits_count: 'créditos IA',
    plan_boards_unlimited: 'Quadros ilimitados',
    plan_boards_count: 'quadro(s)',
    plan_habits_unlimited: 'Hábitos ilimitados',
    plan_habits_count: 'hábitos',
    plan_budget_included: 'Orçamento incluído',
    plan_budget_excluded: 'Orçamento não incluído',
    plan_btn_start_free: 'Começar grátis',
    plan_btn_subscribe: 'Assinar',
    landing_cta_final_title: 'Comece hoje. Seu próximo ano vai agradecer.',
    landing_cta_final_subtitle: 'Crie sua conta grátis em menos de 1 minuto. Sem cartão. Sem compromisso.',
    landing_cta_final_btn: 'Criar minha conta grátis',
    landing_questions: 'Dúvidas? Escreva para',
    tag_free: 'Plano inicial · Grátis para sempre',
    tag_light: 'Para manter o ritmo',
    tag_pro: 'Para trabalhar melhor',
    tag_vip: 'Sem limites · Orçamento incluído',
    tag_trimestral: 'Melhor valor a longo prazo',
    feat_vb_t: 'Vision Board',
    feat_vb_d: 'Envie imagens, frases e colagens que representem o que você quer atrair. Quadros ilimitados, drag-and-drop livre.',
    feat_habits_t: 'Hábitos diários',
    feat_habits_d: 'Defina rotinas, marque seu check-in e veja sua sequência e porcentagem de cumprimento do mês com lembretes.',
    feat_goals_t: 'Metas com IA',
    feat_goals_d: 'Escreva sua meta e a IA gera os passos acionáveis. Leve-os ao calendário em um clique.',
    feat_cal_t: 'Calendário time-blocking',
    feat_cal_d: 'Visualização por dia, semana ou mês com blocos arrastáveis. A IA pode organizar sua semana.',
    feat_journal_t: 'Diário livre',
    feat_journal_d: 'Escreva sem filtro. A IA acompanha com reflexões empáticas e perguntas abertas. Múltiplos cadernos.',
    feat_clarity_t: 'Clareza Mental',
    feat_clarity_d: 'Caixa de ideias com 3 zonas (Adiável / Prioridade / Ruído). Para esvaziar a cabeça em 2 minutos.',
    feat_achv_t: 'Arquivo de conquistas',
    feat_achv_d: 'Cada meta cumprida fica guardada como lembrete de tudo o que você já conquistou.',
    feat_budget_t: 'Orçamento',
    feat_budget_d: 'Tabelas financeiras, rastreador diário, savings goals, projeções e saldo histórico acumulativo.',
    bnf_rhythm_t: 'Feito para o seu ritmo',
    bnf_rhythm_d: 'Não é um app de produtividade agressivo. Você avança com calma, sem culpa, com sua energia.',
    bnf_data_t: 'Seus dados, seus',
    bnf_data_d: 'Criptografia em trânsito, controle total sobre suas informações e possibilidade de exportar tudo quando quiser.',
    bnf_pay_t: 'Pagamentos seguros',
    bnf_pay_d: 'Processamos pagamentos por meio de um provedor de serviços de pagamento autorizado. Seus dados de cartão nunca passam pelos nossos servidores.',
    // Contact
    contact_kicker: 'Contato',
    contact_title: 'Vamos conversar',
    contact_subtitle: 'Se você tem uma dúvida, sugestão, problema técnico ou quer cancelar sua assinatura, escreva para nós. Respondemos em 24-48h úteis.',
    contact_email_label: 'Email de contato',
    contact_field_name: 'Nome',
    contact_field_email: 'Email',
    contact_field_subject: 'Assunto',
    contact_field_message: 'Mensagem',
    contact_subject_placeholder: 'Dúvida geral, problema técnico, cancelamento...',
    contact_message_placeholder: 'Conte-nos em que podemos ajudar...',
    contact_send: 'Enviar mensagem',
    contact_required_fields: 'Preencha nome, email e mensagem',
    contact_sent_title: 'Recebemos sua mensagem!',
    contact_sent_body_pre: 'Respondemos para',
    contact_sent_body_post: 'nas próximas 24-48h úteis.',
    contact_send_another: 'Enviar outra mensagem',
    contact_success_toast: 'Mensagem enviada! Respondemos em breve.',
    contact_error_toast: 'Não conseguimos enviar a mensagem. Tente o botão "Abrir email".',
    contact_consent: 'Ao enviar, você aceita nossa',
    contact_consent_link: 'política de privacidade',
    contact_default_subject: 'Consulta do Teko',
    // Notifications
    notifications: 'Notificações',
    notif_aria: 'Notificações',
    notif_empty: 'Você não tem notificações.',
    notif_empty_hint: 'Avisaremos sobre hábitos pendentes, eventos próximos e metas perto do vencimento.',
    notif_mark_all: 'Marcar lidas',
    notif_mark_one: 'Marcar lida',
    notif_remove: 'Excluir',
    notif_new_badge: 'novas',
    notif_just_now: 'agora mesmo',
    notif_minutes_ago: 'min',
    notif_hours_ago: 'h',
    // Onboarding
    tour_skip: 'Pular tour',
    tour_prev: 'Anterior',
    tour_next: 'Próximo',
    tour_start: 'Começar',
    tour_step: 'Passo',
    tour_of: 'de',
    tour_close: 'Fechar tour',
    tour_1_t: 'Bem-vindo ao Teko!',
    tour_1_b: 'Sou seu guia. Vou mostrar as funcionalidades principais em 30 segundos. Você pode pular o tour quando quiser — sempre pode reabrir pelo botão "Guia Teko" no canto inferior direito.',
    tour_2_t: 'Painel principal',
    tour_2_b: 'Aqui você vê seu resumo do dia: hábitos pendentes, metas ativas, próximos eventos e um resumo semanal gerado por IA.',
    tour_3_t: 'Vision Board',
    tour_3_b: 'Envie imagens, frases e colagens que representem o que você quer atrair. Pode criar vários quadros e arrastar elementos livremente.',
    tour_4_t: 'Hábitos',
    tour_4_b: 'Defina hábitos diários ou semanais, marque seu check-in e veja sua sequência e porcentagem de cumprimento do mês. Os lembretes aparecem nas notificações.',
    tour_5_t: 'Metas com IA',
    tour_5_b: 'Escreva uma meta e a IA gera os passos acionáveis. Depois pode levar cada passo ao calendário em um clique.',
    tour_6_t: 'Calendário time-blocking',
    tour_6_b: 'Visualização por dia, semana ou mês com blocos arrastáveis. A IA pode organizar sua semana se você contar suas prioridades.',
    tour_7_t: 'Diário livre',
    tour_7_b: 'Escreva sem filtro. A IA acompanha com reflexões empáticas e perguntas abertas. Suporta múltiplos cadernos por tema.',
    tour_8_t: 'Conquistas',
    tour_8_b: 'Cada meta cumprida fica arquivada aqui como lembrete de tudo o que você já conquistou.',
    tour_9_t: 'Clareza Mental',
    tour_9_b: 'Caixa de ideias com drag-and-drop para 3 zonas: Adiável, Prioridade e Ruído. Para esvaziar a cabeça em 2 minutos.',
    tour_10_t: 'Orçamento',
    tour_10_b: 'Tabelas financeiras, rastreador de gastos do dia, savings goals e projeções. Esta seção é exclusiva do plano Premium.',
    tour_11_t: 'Assinatura',
    tour_11_b: 'Escolha o plano que combina com você. Free é perfeito para começar, Premium desbloqueia tudo. Pode mudar ou cancelar quando quiser.',
    tour_12_t: 'Pronto para começar!',
    tour_12_b: 'Você já tem o básico. Lembre-se: o botão "Guia Teko" no canto inferior direito abre um chat com IA caso tenha dúvidas mais específicas.',
    // Tutorial chat
    chat_greeting: 'Olá! Sou o guia do Teko. Me pergunte qualquer coisa sobre as funcionalidades do app — estou aqui para ajudar.',
    chat_subtitle: 'Ajudo com qualquer funcionalidade',
    chat_open_aria: 'Abrir guia do Teko',
    chat_title: 'Guia Teko',
    chat_tour_btn: 'Tour',
    chat_close_aria: 'Fechar',
    chat_send_aria: 'Enviar',
    chat_placeholder: 'Pergunte algo...',
    chat_error: 'Ops, não consegui responder agora. Tente de novo em alguns segundos.',
    chat_sug_1: 'Como adiciono um hábito?',
    chat_sug_2: 'Para que serve a Clareza Mental?',
    chat_sug_3: 'Como funciona o plano Premium?',
    chat_sug_4: 'Como gero metas com IA?',
  },
};

const LanguageContext = createContext({});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('teko-lang') || 'es');

  useEffect(() => { localStorage.setItem('teko-lang', lang); document.documentElement.lang = lang; }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] ?? translations.es[key] ?? key;
  };

  // Locale code for date formatting
  const dateLocale = lang === 'en' ? 'en-US' : lang === 'pt' ? 'pt-BR' : 'es-ES';

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dateLocale, languages: [
      { code: 'es', label: 'Español' },
      { code: 'en', label: 'English' },
      { code: 'pt', label: 'Português' },
    ] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
